import React from "react";

const Description = ({ handleInputChange, value }) => {
  return (
    <div className="container-text-area">
      <textarea
        onChange={handleInputChange}
        name="description"
        value={value}
        maxLength="255"
        rows="5"
      />
    </div>
  );
};

export default Description;
